import * as fromDatatype from '../datatype-library/index';
export interface bl_fi_my_einvoice_from_irb_document_queue_RowInterface {
  	guid: fromDatatype.GuidDataFieldInterface;
	lhdn_document_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_submission_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_internal_id: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_name: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_vrsn_name: fromDatatype.VarcharDatatypeInterface;
	supplier_tin: fromDatatype.VarcharDatatypeInterface;
	supplier_name: fromDatatype.VarcharDatatypeInterface;
	receiver_tin: fromDatatype.VarcharDatatypeInterface;
	issuer_tin: fromDatatype.VarcharDatatypeInterface;
	receiver_name: fromDatatype.VarcharDatatypeInterface;
	date_time_issued: fromDatatype.TimestampTzDatatypeInterface;
	date_time_received: fromDatatype.TimestampTzDatatypeInterface;
	total_sales: fromDatatype.VarcharDatatypeInterface;
	doc_status: fromDatatype.VarcharDatatypeInterface;
	submission_channel: fromDatatype.VarcharDatatypeInterface;
	intermediary_name: fromDatatype.VarcharDatatypeInterface;
	intermediary_tin: fromDatatype.VarcharDatatypeInterface;
	cancel_date_time: fromDatatype.TimestampTzDatatypeInterface;
	reject_request_date_time: fromDatatype.TimestampTzDatatypeInterface;
	buyer_name: fromDatatype.VarcharDatatypeInterface;
	buyer_tin: fromDatatype.VarcharDatatypeInterface;
	receiver_id: fromDatatype.VarcharDatatypeInterface;
	receiver_id_type: fromDatatype.VarcharDatatypeInterface;
	issuer_id: fromDatatype.VarcharDatatypeInterface;
	issuer_id_type: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_from_irb_document_queue_RowClass
  implements bl_fi_my_einvoice_from_irb_document_queue_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	lhdn_document_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_submission_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_internal_id: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_name: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_vrsn_name: fromDatatype.VarcharDatatypeInterface;
	supplier_tin: fromDatatype.VarcharDatatypeInterface;
	supplier_name: fromDatatype.VarcharDatatypeInterface;
	receiver_tin: fromDatatype.VarcharDatatypeInterface;
	issuer_tin: fromDatatype.VarcharDatatypeInterface;
	receiver_name: fromDatatype.VarcharDatatypeInterface;
	date_time_issued: fromDatatype.TimestampTzDatatypeInterface;
	date_time_received: fromDatatype.TimestampTzDatatypeInterface;
	total_sales: fromDatatype.VarcharDatatypeInterface;
	doc_status: fromDatatype.VarcharDatatypeInterface;
	submission_channel: fromDatatype.VarcharDatatypeInterface;
	intermediary_name: fromDatatype.VarcharDatatypeInterface;
	intermediary_tin: fromDatatype.VarcharDatatypeInterface;
	cancel_date_time: fromDatatype.TimestampTzDatatypeInterface;
	reject_request_date_time: fromDatatype.TimestampTzDatatypeInterface;
	buyer_name: fromDatatype.VarcharDatatypeInterface;
	buyer_tin: fromDatatype.VarcharDatatypeInterface;
	receiver_id: fromDatatype.VarcharDatatypeInterface;
	receiver_id_type: fromDatatype.VarcharDatatypeInterface;
	issuer_id: fromDatatype.VarcharDatatypeInterface;
	issuer_id_type: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}
